import { isEmail } from '@seek/validators-js';
import { TextField as BraidTextField } from 'braid-design-system';
import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { parseLabel } from '../parseLabel.tsx';
import type { FormValues, SpecialTextFormFields } from '../types.ts';

interface EmailProps {
  element: SpecialTextFormFields;
}

export const Email = ({ element }: EmailProps) => {
  const { setValue } = useFormContext<FormValues>();
  const label = useMemo(
    () => parseLabel(element.id, element.label, element.labelLinks),
    [element.id, element.label, element.labelLinks],
  );
  return (
    <Controller
      key={element.id}
      name={element.id}
      rules={{
        required: element.required ? 'This field is required' : false,
        validate: element.required
          ? {
              validEmail: (value) =>
                isEmail.test({
                  value,
                  validatorProps: undefined,
                  formValues: undefined,
                })
                  ? true
                  : 'Invalid email',
            }
          : undefined,
      }}
      render={({ field, fieldState }) => (
        <BraidTextField
          label={label}
          placeholder={element.placeholder}
          secondaryLabel={element.secondaryLabel}
          onChange={field.onChange}
          type="email"
          value={field.value}
          message={fieldState.error?.message}
          tone={fieldState.invalid ? 'critical' : undefined}
          onClear={() => setValue(element.id, '')}
        />
      )}
    />
  );
};
